var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllagent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13705",
    "data-name": "Group 13705",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 14,
    height: 14,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13704",
    "data-name": "Group 13704",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M15.2,9.621c0,.162-.141.26-.372.27a5.875,5.875,0,0,0-2.439.608,4.2,4.2,0,0,0-2.33,3.024,12.292,12.292,0,0,0-.153,1.343c-.02.216-.117.338-.3.335s-.293-.124-.294-.342a5.506,5.506,0,0,0-.414-2.2A4.513,4.513,0,0,0,5.367,10a9.3,9.3,0,0,0-1.01-.112C4.124,9.873,4,9.788,4,9.61s.122-.29.363-.3a5.787,5.787,0,0,0,2.612-.688,4.187,4.187,0,0,0,2.17-2.948,10.539,10.539,0,0,0,.147-1.27C9.316,4.129,9.4,4,9.6,4s.289.144.292.423A5.441,5.441,0,0,0,10.3,6.55a4.41,4.41,0,0,0,3.18,2.564,10.445,10.445,0,0,0,1.312.193c.255.03.406.132.4.314",
    transform: "translate(-1.2 -1.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13072",
    "data-name": "Path 13072",
    d: "M5.6,2.81c0,.081-.071.13-.186.135a2.937,2.937,0,0,0-1.219.3A2.1,2.1,0,0,0,3.03,4.761a5.95,5.95,0,0,0-.076.671c-.01.108-.059.169-.15.167s-.146-.062-.146-.171a2.766,2.766,0,0,0-.207-1.1A2.256,2.256,0,0,0,.683,3a4.487,4.487,0,0,0-.5-.056C.062,2.936,0,2.894,0,2.8s.061-.145.181-.149a2.888,2.888,0,0,0,1.306-.344A2.093,2.093,0,0,0,2.572.839,5.352,5.352,0,0,0,2.645.2C2.658.064,2.7,0,2.8,0s.144.072.146.211a2.713,2.713,0,0,0,.207,1.063,2.2,2.2,0,0,0,1.59,1.282,5.385,5.385,0,0,0,.656.1c.127.015.2.066.2.157",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllagent);
export default __webpack_public_path__ + "static/media/allagent.163209435e08f460390e94f66dbbcd4a.svg";
export { ForwardRef as ReactComponent };